// Pure decisions of the Save-script modal (the old Studio's
// SaveServiceModal ported to the new Studio): where a brand-new script
// goes — an existing UDF service or a freshly created one — and the
// field validations both tabs share. UI in SaveScriptModal.tsx, save
// flows in useScriptSaving.ts.

/** The engine appends nothing — the .rhai extension is the client's job. */
export const withRhaiExtension = (name: string): string =>
  name.endsWith(".rhai") ? name : `${name}.rhai`;

// Mirrors the engine's service naming conventions (the old modal's rule):
// lowercase letters, numbers and hyphens.
export function serviceNameProblem(
  trimmed: string,
  existingNames: string[],
): string | null {
  if (trimmed === "") return "Add a name to the service";
  if (!/^[a-z0-9-]+$/.test(trimmed)) {
    return "Lowercase letters, numbers, and hyphens only";
  }
  if (existingNames.includes(trimmed)) {
    return "A service with this name already exists";
  }
  return null;
}

// Mirrors the engine's validate_script_filename (single path component;
// the .rhai extension is appended on save, so it may be typed or not).
export function scriptFilenameProblem(
  raw: string,
  existingFilenames: string[],
): string | null {
  const trimmed = raw.trim();
  if (trimmed === "") return "Add a filename for the script";
  if (!/^[a-zA-Z0-9._-]+$/.test(trimmed)) {
    return "Filename can only contain letters, numbers, dots, underscores, and hyphens";
  }
  if (existingFilenames.includes(withRhaiExtension(trimmed))) {
    return "A script with this filename already exists in the service";
  }
  return null;
}

/** Which tab the modal opens on: picking beats typing while there is
 *  anything to pick. */
export function defaultSaveTab(udfServiceCount: number): "existing" | "new" {
  return udfServiceCount > 0 ? "existing" : "new";
}
